import { Typography, type TypographyProps } from "@octopus-energy/coral/atoms"

export function DataGridValue(props: TypographyProps) {
    return (
        <Typography
            textStyle="h5"
            component="p"
            color="tertiary500"
            {...props}
        />
    )
}
